import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';

import { Paginator, SearchAndFilterToolbar, StatusBar } from "../../components/common";


import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";
import ProductFilter from "./productFilter";
import ProductTable from "./productTable";

import enumChoice from "../../enum";

import { parseSearchParams } from "../common/filterableForm";
import { handleRetriveError } from "../../utils";


function ProductMain() {

    const [products, setProducts] = useState<any>({});
    const [searchParams, setSearchParams] = useSearchParams()
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [filterData, setFilterData] =  useState<any>({});

    const api = useApi();
    const navigate = useNavigate();

    const fetchProducts = () => {
        const queryObject = parseSearchParams(searchParams);
        api.getProducts(queryObject).then((response: any) => {
            setProducts(response);
        }, handleRetriveError);
    };

    useEffect(() => {
        fetchProducts();
    }, [searchParams]);

    useEffect(() => {
        fetchProducts();
    }, []);


    return (
        <>  
            <PageBodyWrapper>
            <StatusBar 
                statusList={enumChoice.publishableStatus} 
                buttonLabel="Add Product"
                onButtonClick={() => navigate('/dashboard/products/add-new-product')}
            />

                <SearchAndFilterToolbar
                    onClearFilters={() => setFilterData({})}
                    onFilterOpen={() => setOpenFilterModal(!openFilterModal)}
                    onRefresh={fetchProducts}
                    startDateKey={"created_at_after"}
                    endDateKey={"created_at_before"}
                />
                {openFilterModal && <ProductFilter onClose={() => setOpenFilterModal(false)} />}
                <div className="relative overflow-x-auto">
                    <ProductTable products={products} fetchProducts={fetchProducts} />
                    <Paginator data={products}/>
                </div>
            </PageBodyWrapper>
        </>
    );
}

export default ProductMain;
